import { HitProps } from '../search/types'
import { getDocumentType } from './utils/document'

import BitwardenIcon from '@/icons/bwi/bitwarden-shield.svg'
import CommunityIcon from '@/icons/bwi/community.svg'
import HelpIcon from '@/icons/bwi/help.svg'
import BlogIcon from '@/icons/bwi/edit.svg'
import ExternalIcon from '@/icons/bwi/external-link.svg'
import GithubIcon from '@/icons/bwi/github.svg'
import ResourcesIcon from '@/icons/bwi/file-pdf.svg'

type SourceBadgeProps = {
  hit: HitProps
  displayType?: 'icon' | 'text' | 'both'
}

export default function SourceBadge({ hit, displayType = 'both' }: SourceBadgeProps) {
  const sourceType = getDocumentType(hit)
  let Icon: typeof BitwardenIcon | null = null
  switch (sourceType) {
    case 'Bitwarden':
      Icon = BitwardenIcon
      break
    case 'Community':
      Icon = CommunityIcon
      break
    case 'Blog':
      Icon = BlogIcon
      break
    case 'Help':
      Icon = HelpIcon
      break
    case 'Resources':
      Icon = ResourcesIcon
      break
    case 'GitHub':
      Icon = GithubIcon
      break
    case 'External':
      Icon = ExternalIcon
      break
  }
  return (
    <span className="flex items-center">
      {Icon && (displayType === 'icon' || displayType === 'both') && <Icon className="w-4 h-4 text-primaryBlue mr-2" />}
      {(displayType === 'text' || displayType === 'both') && (
        <p className="text-xs uppercase tracking-widest mb-0">{sourceType}</p>
      )}
    </span>
  )
}
